import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as Types from './operations';

const defaultOptions = {};

export const UserNotificationDocument = gql`
  subscription UserNotification($topics: [String]) {
    subscribe(topics: $topics) {
      ... on SubscriptionAck {
        __typename
        notifications {
          type
          payload
        }
      }
      ... on Notification {
        __typename
        type
        payload
      }
    }
  }
`;

/**
 * __useUserNotificationSubscription__
 *
 * To run a query within a React component, call `useUserNotificationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserNotificationSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    Types.UserNotificationSubscription,
    Types.UserNotificationSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Types.UserNotificationSubscription,
    Types.UserNotificationSubscriptionVariables
  >(UserNotificationDocument, options);
}
export type UserNotificationSubscriptionHookResult = ReturnType<
  typeof useUserNotificationSubscription
>;
export type UserNotificationSubscriptionResult =
  Apollo.SubscriptionResult<Types.UserNotificationSubscription>;
